module.exports = __webpack_public_path__ + "static/media/HR Board Slide Templates by Thrive.74a50c40.pptx";